import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalsService } from '../../api/globals.service';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ForumsService } from '../../services/forums.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-list-forums',
  templateUrl: './list-forums.component.html',
  styleUrls: ['./list-forums.component.scss'],
})
export class ListForumsComponent implements OnInit {
  @Output() forum = new EventEmitter();
  @Input() typeForum: number;
  @Input() set id_categoria (id){
    this.dataChange();
    this.getCategoryForums(id);
  };

  @Input() set textFind (text){
    this.dataChange();
    this.findForums(text);
  };
  
  private id:number;
  private auth_key:string;
  displayUserData:any;
  forums:any=[];
  idCategoria:string = null;

  colorForums:any=[
    [ '#f8f8fe', '5px 5px #bdade4'],
    [ '#effeff', '5px 5px #8cddeb'],
    [ '#fdedf4', '5px 5px #e2a4be'],
    [ '#fef0e6', '5px 5px #f9b781'],
    [ '#e9fdea', '5px 5px #9fe0a5'],
  ];

  constructor(
    public GlobalsService: GlobalsService,
    public navCtrl:NavController,
    private router:Router,
    private forumServices:ForumsService,
    private authService:AuthService,
    private loadingServices: LoadingService
  ) { }

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      if(!this.displayUserData){
        this.displayUserData =  res;
        this.loadVariables();
        if(this.typeForum == 1)
          this.getTredingForums();
        if(this.typeForum == 2)
          this.getNewsForums();
        if(this.typeForum == 3)
          this.getCategoryForums(null);
        if(this.typeForum == 4)
          this.findForums(null);
      }
    });
  }

  dataChange(){
    this.authService.userData$.subscribe((res: any) => {
      if(!this.displayUserData){
        this.displayUserData =  res;
        this.loadVariables();
      }
    });
  }

  getTredingForums(){
    this.forumServices.getTredingForums(this.id,this.auth_key).subscribe(res=>{
      if(res && res instanceof Array ){
        res.forEach(element => {
          let bc = this.setColor();
          element.backColor = bc[0];
          element.boxShadow = bc[1];
        });
        this.forums = res.sort((a, b) => b.me_gusta - a.me_gusta);
        this.loadingServices.dismiss();
      }

    });
  }

  getNewsForums(){
    this.forumServices.getNewsForums(this.id,this.auth_key).subscribe(res=>{
      
      res.forEach(element => {
        let bc = this.setColor();
        element.backColor = bc[0];
        element.boxShadow = bc[1];
      });
      this.forums = res.sort((a, b) => b.me_gusta - a.me_gusta);
      this.loadingServices.dismiss();
    });
  }

  getCategoryForums(id_cat){
   // alert(this.id+' '+this.auth_key+' '+this.idCategoria+' '+id_cat);
    this.forumServices.getForumsbyCategory(this.id,this.auth_key, id_cat).subscribe(res=>{
      res.forEach(element => {
        let bc = this.setColor();
        element.backColor = bc[0];
        element.boxShadow = bc[1];
      });
      this.forums = res.sort((a, b) => b.me_gusta - a.me_gusta);
      this.loadingServices.dismiss();
    });
  }

  findForums(text){
    this.forumServices.findForums(this.id,this.auth_key,text).subscribe(res=>{
      res.forEach(element => {
        let bc = this.setColor();
        element.backColor = bc[0];
        element.boxShadow = bc[1];
      });
      this.forums = res.sort((a, b) => b.me_gusta - a.me_gusta);
      this.loadingServices.dismiss();
    });
  }

  loadVariables(){
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
    this.idCategoria = this.id_categoria;
  }

  setColor() { 
    let max =  (this.colorForums.length - 1);
    let posColor =  Math.floor(Math.random() * (max - 0)) + 0;
    return this.colorForums[posColor];
  }


  comments(idForum){
    this.forum.emit(idForum);
  }

}
